'use strict';

const { openSupportTicket } = require('../subscriptions/apiSubscriptions');

const apiStates = ({ elm }) => {
	return [
		{
			name: 'site.Api',
			url: '/apisettings',
			templateUrl: 'components/apiApp/pmtApiAppMenu.html',
			redirectTo: 'site.Api.Access'
		},
		elm({
			name: 'site.API-V3-Credentials',
			moduleName: 'API.V3.Credentials.Main',
			url: '/api/v3/credentials',
			requiredPermission: 'permission/api.documentation',
			pageTitle: 'listings.navigation.api_v3'
		}),
		elm({
			name: 'site.API-V3-Documentation',
			moduleName: 'API.V3.Documentation',
			url: '/api/v3/documentation',
			requiredPermission: 'permission/api.documentation',
			pageTitle: 'listings.navigation.api_v3'
		}),
		{
			name: 'site.Api.PendingChanges',
			moduleName: 'ApiPendingChanges.Resolver.Main',
			url: '/pendingchanges',
			component: 'pmtApiPendingChangesResolver'
		},
		elm({
			name: 'site.Api.Changes',
			moduleName: 'ApiPendingChanges.Log.Main',
			url: '/changes',
			requiredPermission: 'role/owner',
			pageTitle: 'listings.api_difference.api_differences_title'
		}),
		elm({
			name: 'site.Api.Documentation',
			moduleName: 'ApiDocumentation.ApiDocumentation',
			url: '/documentation',
			requiredPermission: 'permission/location.view',
			pageTitle: 'listings.api_documentation.api_documentation_page_title',
			argsResolver: [
				'$stateParams',
				'auth',
				'pmtEnvService',
				async ($stateParams, auth, pmtEnvService) => {
					return {
						siteName: $stateParams.site || $stateParams.siteName,
						apiEnabled: await auth.getUser($stateParams.site).then(user => {
							return user.selectedSite.places?.api?.enabled || false;
						}),
						apiDocUrlV3: pmtEnvService.apiV3Url + 'documentation/v3/',
						apiDocUrlV4: pmtEnvService.apiV3Url + 'documentation/v4/',
						apiDocUrlMediaV1: pmtEnvService.apiV3Url + 'documentation/media/v1/',
						apiDocUrlLocationsV4: pmtEnvService.apiV3Url + 'documentation/locations/v4/',
						apiAppUrl: pmtEnvService.accountSettingsUrl + auth.user.selectedSite.name + '/api/v3/'
					};
				}
			],
			subscriptions: ['pmtElmService', pmtElmService => [openSupportTicket(pmtElmService)]]
		})
	];
};

module.exports = {
	apiStates
};
